import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import AeroIcon from '../Aero/AeroIcon';
import './FeedbackModal.css';

export default function FeedbackModal({ show, onHide }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onHide();
    };
    if (show) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [show, onHide]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div className="aero-feedback-overlay" onClick={onHide}>
      <div className="aero-feedback-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="aero-feedback-close"
          onClick={onHide}
          aria-label="Close"
        >
          <AeroIcon name="x" />
        </button>
        <h2 className="aero-feedback-title">Send feedback</h2>
        <p className="aero-feedback-sub">
          Something broken, something missing, or anything else. Every message is read.
        </p>
        <div className="aero-feedback-iframe-wrapper">
          <div className="aero-feedback-iframe-mask"></div>
          <iframe
            src="https://duaneharrison.notion.site/ebd//3479ec18a31a8091a910e9282d2dce4c"
            width="100%"
            height="900"
            frameBorder="0"
            allowFullScreen
            loading="lazy"
            title="Aero Feedback Form"
          />
        </div>
      </div>
    </div>,
    document.body
  );
}
